import { render, staticRenderFns } from "./SoalStart.vue?vue&type=template&id=432d1cc0&scoped=true"
import script from "./SoalStart.vue?vue&type=script&lang=js"
export * from "./SoalStart.vue?vue&type=script&lang=js"
import style0 from "./SoalStart.vue?vue&type=style&index=0&id=432d1cc0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "432d1cc0",
  null
  
)

export default component.exports